/** The floating side rail: library, search and queue. */

import type { Component } from 'solid-js';
import { showLibrary, showQueue, showSearch } from '../../app/browse.ts';
import { Library, QueueList, Search } from '../icons/nav.tsx';
import { GlassButton } from '../primitives/Glass.tsx';
import styles from './Hud.module.css';

export const Rail: Component = () => (
  <div class={styles.rail}>
    <GlassButton label="Library" title="Library (L)" onClick={showLibrary}>
      <Library />
    </GlassButton>
    <GlassButton label="Search" title="Search (S)" onClick={showSearch}>
      <Search />
    </GlassButton>
    <GlassButton label="Queue" title="Queue (Q)" onClick={showQueue}>
      <QueueList />
    </GlassButton>
  </div>
);
